export const isNumeric = (num: string): boolean => num.length > 0 && !Number.isNaN(Number(num));
